import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-modal-importar',
  templateUrl: './modal-importar.component.html',
  styleUrls: ['./modal-importar.component.scss']
})
export class ModalImportarComponent implements OnInit {

  idiomaElegido: any;

  infoDominio: any = {
    enable: false,
    url: ''
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public datos: any,
    public dialogRef: MatDialogRef<ModalImportarComponent>,
  ) { }

  ngOnInit() {
    console.log("datosRecibidos:",this.datos);

    if(this.datos.tipo != undefined){
      if(this.datos.domain != null){
        this.infoDominio = this.datos.domain;
      }
    }
  }

  salir() {
    this.dialogRef.close(this.idiomaElegido);
  }
  salirConfig(){
    this.dialogRef.close(this.infoDominio);
  }

}
